import styled from 'styled-components'

import { colors } from '../../constants'

export const Confirmation = styled.div`
    min-width: 500px;
    text-align: left;
`

export const Header = styled.div`
    color: ${colors.bluedarkest};
    font-weight: bold;
    font-size: 28px;
    overflow: hidden;
    white-space: nowrap;
    padding: 2px;
    margin-left: 10px;
`

export const Divider = styled.div`
    height: 2px;
    width: 100%;
    border-top: 1px solid ${colors.bluelighter};
`

export const Content = styled.div`
    color: ${colors.grey};
    font-weight: bold;
    font-size: 17px;
    overflow: hidden;
    white-space: nowrap;
    padding: 2px;
    margin: 10px;
    margin-bottom: 15px;
`

export const Buttons = styled.div`
    text-align: right;
`
